import { register_logger } from '@shared/utils/utils_logs';
import { ServiceLoggerTerminalClient } from './terminal/service_logger_terminal_client';

export function init_loggers_local() {
  register_logger(new ServiceLoggerTerminalClient());
}
